import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone/builds/moment-timezone-with-data'

import MomentLocaleUtils from 'react-day-picker/moment'
import DayPicker, { DateUtils } from 'react-day-picker'

class ReservationDatePicker extends React.Component {
  componentDidMount() {
    this.dayPicker.showMonth(this.props.date || new Date())
  }

  getDayPickerModifiers() {
    const { date, dates, timezone } = this.props
    const theDate = moment.tz(date, timezone)
    const formattedDates = dates.map(({ m }) => m.format('YYYY-MM-DD'))

    return {
      selected: day => {
        const theYear = Number(theDate.format('YYYY'))
        const theMonth = Number(theDate.format('MM'))
        const theDay = Number(theDate.format('DD'))
        const thisYear = day.getFullYear()
        const thisMonth = day.getMonth() + 1
        const thisDay = day.getDate()

        return (
          theYear === thisYear &&
          theMonth === thisMonth &&
          theDay === thisDay
        )
      },
      disabled: day => {
        if (DateUtils.isPastDay(day)) {
          return true
        }

        const selectedDayString = moment
          .tz(day, timezone)
          .format('YYYY-MM-DD')
        const found = formattedDates
          .find((d) => d === selectedDayString)

        return !found
      },
    }
  }

  render() {
    const {
      date,
      dates,
      timezone,
      locale,
      dateSelected,
    } = this.props

    if (
      !dates ||
      !timezone ||
      !locale ||
      !dateSelected
    ) {
      return null
    }

    const modifiers = this.getDayPickerModifiers(date, dates, timezone)

    return (<DayPicker
      localeUtils={MomentLocaleUtils}
      locale={locale}
      fromMonth={new Date}
      modifiers={modifiers}
      onDayClick={dateSelected}
      ref={ el => this.dayPicker = el }
    />)
  }
}

ReservationDatePicker.propTypes = {
  date: PropTypes.string.isRequired,
  dates: PropTypes.array.isRequired,
  timezone: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  dateSelected: PropTypes.func.isRequired,
}

export default ReservationDatePicker
